<template>
  <div class="container-fluid" style="overflow-x: hidden;">
    <div v-if="user" class="row">
      <div class="col-12">
        <textarea id="story" name="positions" rows="5" v-model="positions" style="width: 100%;"> </textarea>
      </div>
      <div class="col-12">
        <Analyze :scan="scan" :user="user" :positions="positions" />
      </div>
      <div class="col-12">
        <Compare :scan="scan" :user="user" :positions="positions" />
      </div>
    </div>
    <RenderNoUser v-else />
  </div>
</template>
<script>
import Analyze from "./Analyze.vue";
import Compare from "./Compare.vue";
import RenderNoUser from "./RenderNoUser.vue";

export default {
  components: { Analyze, Compare, RenderNoUser },
  props: ["user"],
  data() {
    return {
      positions: [
        {
          platform: "fortuneo",
          label: "Compte-titres M BRUNET MAXIME",
          currency: "EUR",
          type: 5,
          balance: 6175.24,
          diff: 176019.168,
          diff_percent: 0.6154,
          prev_diff: 517.691,
          prev_diff_percent: 0.0011,
          valuation: 462057.118,
          calculated: ["diff", "diff_percent", "prev_diff", "pref_diff_percent", "valuation"],
          investments: [
            {
              id: 586,
              id_account: 437,
              label: "LVMH MOET HENNESSY VUITTON",
              code: "FR0000121014",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 50.0,
              unitprice: 57.114,
              unitvalue: 800.0,
              valuation: 40000.0,
              diff: 37144.29,
              diff_percent: 13.00702,
              prev_diff: 60.0,
              portfolio_share: 0.0866,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 248,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 2855.71,
              original_unitvalue: 800.0,
              original_unitprice: 57.114,
              original_diff: 37144.29,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.0015,
            },
            {
              id: 585,
              id_account: 437,
              label: "L'OREAL",
              code: "FR0000120321",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 100.0,
              unitprice: 126.946,
              unitvalue: 378.05,
              valuation: 37805.0,
              diff: 25110.38,
              diff_percent: 1.97803,
              prev_diff: -225.0,
              portfolio_share: 0.0818,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 247,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 12694.62,
              original_unitvalue: 378.05,
              original_unitprice: 126.946,
              original_diff: 25110.38,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: -0.0059,
            },
            {
              id: 584,
              id_account: 437,
              label: "HSBC SMALL CAP FRANCE AC/D",
              code: "FR0010058628",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 12.0,
              unitprice: 377.108,
              unitvalue: 2206.42,
              valuation: 26477.04,
              diff: 21951.75,
              diff_percent: 4.8509,
              prev_diff: 111.36,
              portfolio_share: 0.0573,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 246,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 4525.29,
              original_unitvalue: 2206.42,
              original_unitprice: 377.108,
              original_diff: 21951.75,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.0042,
            },
            {
              id: 583,
              id_account: 437,
              label: "HSBC ACTIONS FRANCE C",
              code: "FR0000439226",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 16.454,
              unitprice: 468.266,
              unitvalue: 1462.86,
              valuation: 24069.898,
              diff: 16365.048,
              diff_percent: 2.12399,
              prev_diff: 81.611,
              portfolio_share: 0.0521,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 245,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 7704.85,
              original_unitvalue: 1462.86,
              original_unitprice: 468.266,
              original_diff: 16365.048,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.0034,
            },
            {
              id: 594,
              id_account: 437,
              label: "SCHNEIDER ELECTRIC",
              code: "FR0000121972",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 150.0,
              unitprice: 32.961,
              unitvalue: 148.32,
              valuation: 22248.0,
              diff: 17303.88,
              diff_percent: 3.49989,
              prev_diff: 171.0,
              portfolio_share: 0.0481,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 255,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 4944.12,
              original_unitvalue: 148.32,
              original_unitprice: 32.961,
              original_diff: 17303.88,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.0077,
            },
            {
              id: 592,
              id_account: 437,
              label: "SAFRAN PROV.ECHANGE",
              code: "FR0000073272",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 150.0,
              unitprice: 33.99,
              unitvalue: 131.8,
              valuation: 19770.0,
              diff: 14671.53,
              diff_percent: 2.87763,
              prev_diff: -60.0,
              portfolio_share: 0.0428,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-27",
              id_security: 253,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 5098.47,
              original_unitvalue: 131.8,
              original_unitprice: 33.99,
              original_diff: 14671.53,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: -0.003,
            },
            {
              id: 591,
              id_account: 437,
              label: "REMY COINTREAU",
              code: "FR0000130395",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 111.0,
              unitprice: 37.445,
              unitvalue: 172.6,
              valuation: 19158.6,
              diff: 15002.22,
              diff_percent: 3.60944,
              prev_diff: 355.2,
              portfolio_share: 0.0415,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 252,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 4156.38,
              original_unitvalue: 172.6,
              original_unitprice: 37.445,
              original_diff: 15002.22,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.0189,
            },
            {
              id: 570,
              id_account: 437,
              label: "AIR LIQUIDE",
              code: "FR0000120073",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 121.0,
              unitprice: 82.917,
              unitvalue: 146.06,
              valuation: 17673.26,
              diff: 7640.28,
              diff_percent: 0.76152,
              prev_diff: -215.38,
              portfolio_share: 0.0382,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 235,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 10032.98,
              original_unitvalue: 146.06,
              original_unitprice: 82.917,
              original_diff: 7640.28,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: -0.012,
            },
            {
              id: 582,
              id_account: 437,
              label: "HERMES INTERNATIONAL",
              code: "FR0000052292",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 10.0,
              unitprice: 282.719,
              unitvalue: 1714.5,
              valuation: 17145.0,
              diff: 14317.81,
              diff_percent: 5.06433,
              prev_diff: 85.0,
              portfolio_share: 0.0371,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 244,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 2827.19,
              original_unitvalue: 1714.5,
              original_unitprice: 282.719,
              original_diff: 14317.81,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.005,
            },
            {
              id: 601,
              id_account: 437,
              label: "VEOLIA ENVIRONNEMENT",
              code: "FR0000124141",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 592.0,
              unitprice: 24.557,
              unitvalue: 27.18,
              valuation: 16090.56,
              diff: 1552.93,
              diff_percent: 0.10682,
              prev_diff: -124.32,
              portfolio_share: 0.0348,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 88,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 14537.63,
              original_unitvalue: 27.18,
              original_unitprice: 24.557,
              original_diff: 1552.93,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: -0.0077,
            },
            {
              id: 587,
              id_account: 437,
              label: "MICHELIN",
              code: "FR001400AJ45",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 500.0,
              unitprice: 9.161,
              unitvalue: 28.955,
              valuation: 14477.5,
              diff: 9896.85,
              diff_percent: 2.16058,
              prev_diff: 167.5,
              portfolio_share: 0.0313,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 249,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 4580.65,
              original_unitvalue: 28.955,
              original_unitprice: 9.161,
              original_diff: 9896.85,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.0117,
            },
            {
              id: 599,
              id_account: 437,
              label: "UNIVERSAL MUSIC GROUP",
              code: "NL0015000IY2",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 508.0,
              unitprice: 25.175,
              unitvalue: 23.47,
              valuation: 11922.76,
              diff: -865.99,
              diff_percent: -0.06771,
              prev_diff: -83.82,
              portfolio_share: 0.0258,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 259,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 12788.75,
              original_unitvalue: 23.47,
              original_unitprice: 25.175,
              original_diff: -865.99,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: -0.007,
            },
            {
              id: 602,
              id_account: 437,
              label: "VINCI",
              code: "FR0000125486",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 100.0,
              unitprice: 80.076,
              unitvalue: 103.64,
              valuation: 10364.0,
              diff: 2356.37,
              diff_percent: 0.29427,
              prev_diff: -28.0,
              portfolio_share: 0.0224,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 261,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 8007.63,
              original_unitvalue: 103.64,
              original_unitprice: 80.076,
              original_diff: 2356.37,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: -0.0027,
            },
            {
              id: 567,
              id_account: 437,
              label: "AEROPORTS DE PARIS",
              code: "FR0010340141",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 70.0,
              unitprice: 125.434,
              unitvalue: 142.25,
              valuation: 9957.5,
              diff: 1177.15,
              diff_percent: 0.13407,
              prev_diff: -136.5,
              portfolio_share: 0.0216,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 233,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 8780.35,
              original_unitvalue: 142.25,
              original_unitprice: 125.434,
              original_diff: 1177.15,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: -0.0135,
            },
            {
              id: 588,
              id_account: 437,
              label: "NEXANS",
              code: "FR0000044448",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 100.0,
              unitprice: 36.259,
              unitvalue: 97.1,
              valuation: 9710.0,
              diff: 6084.09,
              diff_percent: 1.67795,
              prev_diff: 200.0,
              portfolio_share: 0.021,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 250,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 3625.91,
              original_unitvalue: 97.1,
              original_unitprice: 36.259,
              original_diff: 6084.09,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.021,
            },
            {
              id: 568,
              id_account: 437,
              label: "AIRBUS",
              code: "NL0000235190",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 82.0,
              unitprice: 17.736,
              unitvalue: 114.84,
              valuation: 9416.88,
              diff: 7962.53,
              diff_percent: 5.47498,
              prev_diff: -55.76,
              portfolio_share: 0.0204,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 234,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 1454.35,
              original_unitvalue: 114.84,
              original_unitprice: 17.736,
              original_diff: 7962.53,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: -0.0059,
            },
            {
              id: 593,
              id_account: 437,
              label: "SANOFI",
              code: "FR0000120578",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 100.0,
              unitprice: 62.887,
              unitvalue: 89.67,
              valuation: 8967.0,
              diff: 2678.31,
              diff_percent: 0.42589,
              prev_diff: -12.0,
              portfolio_share: 0.0194,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 254,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 6288.69,
              original_unitvalue: 89.67,
              original_unitprice: 62.887,
              original_diff: 2678.31,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: -0.0013,
            },
            {
              id: 590,
              id_account: 437,
              label: "ORANGE",
              code: "FR0000133308",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 900.0,
              unitprice: 17.135,
              unitvalue: 9.722,
              valuation: 8749.8,
              diff: -6671.43,
              diff_percent: -0.43261,
              prev_diff: 95.4,
              portfolio_share: 0.0189,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 17,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 15421.23,
              original_unitvalue: 9.722,
              original_unitprice: 17.135,
              original_diff: -6671.43,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.011,
            },
            {
              id: 572,
              id_account: 437,
              label: "AXA",
              code: "FR0000120628",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 300.0,
              unitprice: 18.027,
              unitvalue: 28.615,
              valuation: 8584.5,
              diff: 3176.34,
              diff_percent: 0.58732,
              prev_diff: -7.5,
              portfolio_share: 0.0186,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 87,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 5408.16,
              original_unitvalue: 28.615,
              original_unitprice: 18.027,
              original_diff: 3176.34,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: -0.0009,
            },
            {
              id: 579,
              id_account: 437,
              label: "ESSILORLUXOTTICA",
              code: "FR0000121667",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 50.0,
              unitprice: 118.426,
              unitvalue: 167.9,
              valuation: 8395.0,
              diff: 2473.69,
              diff_percent: 0.41776,
              prev_diff: 75.0,
              portfolio_share: 0.0182,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 242,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 5921.31,
              original_unitvalue: 167.9,
              original_unitprice: 118.426,
              original_diff: 2473.69,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.009,
            },
            {
              id: 576,
              id_account: 437,
              label: "CARREFOUR",
              code: "FR0000120172",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 432.0,
              unitprice: 28.989,
              unitvalue: 17.47,
              valuation: 7547.04,
              diff: -4976.04,
              diff_percent: -0.39735,
              prev_diff: -30.24,
              portfolio_share: 0.0163,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 239,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 12523.08,
              original_unitvalue: 17.47,
              original_unitprice: 28.989,
              original_diff: -4976.04,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: -0.004,
            },
            {
              id: 577,
              id_account: 437,
              label: "EDENRED",
              code: "FR0010908533",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 150.0,
              unitprice: 22.06,
              unitvalue: 49.99,
              valuation: 7498.5,
              diff: 4189.51,
              diff_percent: 1.2661,
              prev_diff: -97.5,
              portfolio_share: 0.0162,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 240,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 3308.99,
              original_unitvalue: 49.99,
              original_unitprice: 22.06,
              original_diff: 4189.51,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: -0.0128,
            },
            {
              id: 581,
              id_account: 437,
              label: "FDJ",
              code: "FR0013451333",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 164.0,
              unitprice: 19.522,
              unitvalue: 39.25,
              valuation: 6437.0,
              diff: 3235.38,
              diff_percent: 1.01054,
              prev_diff: -247.64,
              portfolio_share: 0.0139,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 33,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 3201.62,
              original_unitvalue: 39.25,
              original_unitprice: 19.522,
              original_diff: 3235.38,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: -0.037,
            },
            {
              id: 598,
              id_account: 437,
              label: "TRIGANO",
              code: "FR0005691656",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 50.0,
              unitprice: 151.676,
              unitvalue: 127.8,
              valuation: 6390.0,
              diff: -1193.78,
              diff_percent: -0.15741,
              prev_diff: 150.0,
              portfolio_share: 0.0138,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 258,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 7583.78,
              original_unitvalue: 127.8,
              original_unitprice: 151.676,
              original_diff: -1193.78,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.024,
            },
            {
              id: 575,
              id_account: 437,
              label: "BNP PARIBAS ACTIONS A",
              code: "FR0000131104",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 100.0,
              unitprice: 51.223,
              unitvalue: 62.9,
              valuation: 6290.0,
              diff: 1167.73,
              diff_percent: 0.22797,
              prev_diff: 79.0,
              portfolio_share: 0.0136,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 5,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 5122.27,
              original_unitvalue: 62.9,
              original_unitprice: 51.223,
              original_diff: 1167.73,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.0127,
            },
            {
              id: 569,
              id_account: 437,
              label: "AIR FRANCE-KLM",
              code: "FR0000031122",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 4000.0,
              unitprice: 2.876,
              unitvalue: 1.548,
              valuation: 6192.0,
              diff: -5310.4,
              diff_percent: -0.46168,
              prev_diff: -52.0,
              portfolio_share: 0.0134,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 19,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 11502.4,
              original_unitvalue: 1.548,
              original_unitprice: 2.876,
              original_diff: -5310.4,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: -0.0083,
            },
            {
              id: 566,
              id_account: 437,
              label: "ACCOR",
              code: "FR0000120404",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 200.0,
              unitprice: 35.594,
              unitvalue: 29.77,
              valuation: 5954.0,
              diff: -1164.8,
              diff_percent: -0.16362,
              prev_diff: 14.0,
              portfolio_share: 0.0129,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 4,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 7118.8,
              original_unitvalue: 29.77,
              original_unitprice: 35.594,
              original_diff: -1164.8,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.0024,
            },
            {
              id: 600,
              id_account: 437,
              label: "VALEO",
              code: "FR0013176526",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 285.0,
              unitprice: 12.622,
              unitvalue: 19.985,
              valuation: 5695.725,
              diff: 2098.455,
              diff_percent: 0.58335,
              prev_diff: 94.05,
              portfolio_share: 0.0123,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 260,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 3597.27,
              original_unitvalue: 19.985,
              original_unitprice: 12.622,
              original_diff: 2098.455,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.0168,
            },
            {
              id: 595,
              id_account: 437,
              label: "SEB",
              code: "FR0000121709",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 55.0,
              unitprice: 143.913,
              unitvalue: 95.85,
              valuation: 5271.75,
              diff: -2643.47,
              diff_percent: -0.33397,
              prev_diff: 387.75,
              portfolio_share: 0.0114,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 256,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 7915.22,
              original_unitvalue: 95.85,
              original_unitprice: 143.913,
              original_diff: -2643.47,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.0794,
            },
            {
              id: 603,
              id_account: 437,
              label: "VIVENDI SE",
              code: "FR0000127771",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 500.0,
              unitprice: 30.362,
              unitvalue: 9.858,
              valuation: 4929.0,
              diff: -10251.95,
              diff_percent: -0.67532,
              prev_diff: -46.0,
              portfolio_share: 0.0107,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 262,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 15180.95,
              original_unitvalue: 9.858,
              original_unitprice: 30.362,
              original_diff: -10251.95,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: -0.0092,
            },
            {
              id: 573,
              id_account: 437,
              label: "BENETEAU",
              code: "FR0000035164",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 300.0,
              unitprice: 10.96,
              unitvalue: 15.02,
              valuation: 4506.0,
              diff: 1217.97,
              diff_percent: 0.37043,
              prev_diff: 36.0,
              portfolio_share: 0.0098,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 237,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 3288.03,
              original_unitvalue: 15.02,
              original_unitprice: 10.96,
              original_diff: 1217.97,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.0081,
            },
            {
              id: 571,
              id_account: 437,
              label: "ALSTOM",
              code: "FR0010220475",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 151.0,
              unitprice: 37.831,
              unitvalue: 27.2,
              valuation: 4107.2,
              diff: -1605.31,
              diff_percent: -0.28102,
              prev_diff: -67.95,
              portfolio_share: 0.0089,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 236,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 5712.51,
              original_unitvalue: 27.2,
              original_unitprice: 37.831,
              original_diff: -1605.31,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: -0.0163,
            },
            {
              id: 574,
              id_account: 437,
              label: "BIC",
              code: "FR0000120966",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 60.0,
              unitprice: 52.717,
              unitvalue: 66.7,
              valuation: 4002.0,
              diff: 838.98,
              diff_percent: 0.26525,
              prev_diff: 30.0,
              portfolio_share: 0.0087,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 238,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 3163.02,
              original_unitvalue: 66.7,
              original_unitprice: 52.717,
              original_diff: 838.98,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.0076,
            },
            {
              id: 589,
              id_account: 437,
              label: "NOKIA",
              code: "FI0009000681",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 830.0,
              unitprice: 13.227,
              unitvalue: 4.3425,
              valuation: 3604.275,
              diff: -7374.385,
              diff_percent: -0.6717,
              prev_diff: -41.5,
              portfolio_share: 0.0078,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 251,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 10978.66,
              original_unitvalue: 4.3425,
              original_unitprice: 13.227,
              original_diff: -7374.385,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: -0.0114,
            },
            {
              id: 578,
              id_account: 437,
              label: "ELIS PROMESSES",
              code: "FR0012435121",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 205.0,
              unitprice: 16.836,
              unitvalue: 16.1,
              valuation: 3300.5,
              diff: -150.84,
              diff_percent: -0.0437,
              prev_diff: 51.25,
              portfolio_share: 0.0071,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 241,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 3451.34,
              original_unitvalue: 16.1,
              original_unitprice: 16.836,
              original_diff: -150.84,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.0158,
            },
            {
              id: 596,
              id_account: 437,
              label: "SOCIETE GENERALE",
              code: "FR0000130809",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 92.0,
              unitprice: 94.273,
              unitvalue: 27.28,
              valuation: 2509.76,
              diff: -6163.34,
              diff_percent: -0.71063,
              prev_diff: 61.18,
              portfolio_share: 0.0054,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 257,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 8673.1,
              original_unitvalue: 27.28,
              original_unitprice: 94.273,
              original_diff: -6163.34,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.025,
            },
            {
              id: 580,
              id_account: 437,
              label: "EUROAPI",
              code: "FR0014008VX5",
              code_type: "ISIN",
              stock_symbol: null,
              stock_market: null,
              source: "website",
              description: "",
              quantity: 4.0,
              unitprice: 12.5,
              unitvalue: 14.765,
              valuation: 59.06,
              diff: 9.06,
              diff_percent: 0.1812,
              prev_diff: 3.9,
              portfolio_share: 0.0001,
              vdate: "2023-01-31",
              prev_vdate: "2023-01-30",
              id_security: 243,
              original_currency: {
                id: "EUR",
                symbol: "€",
                prefix: false,
                crypto: false,
                precision: 2,
                marketcap: null,
                datetime: null,
                name: "Euro",
              },
              original_valuation: 50.0,
              original_unitvalue: 14.765,
              original_unitprice: 12.5,
              original_diff: 9.06,
              last_update: "2023-02-02 11:16:36",
              deleted: null,
              calculated: ["prev_diff_percent", "portfolio_share"],
              id_type: null,
              prev_diff_percent: 0.0707,
            },
          ],
          total: 1,
        },
      ],
    };
  },
  mounted() {},
  methods: {
    async scan(url) {
      return axios({
        method: "post",
        url: url,
        data: { positions: this.positions },
        onDownloadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          const progress = Math.round((loaded / total) * 100);
          console.log(`Download progress: ${progress}%`);
        },
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          const progress = Math.round((loaded / total) * 100);
          console.log(`Upload progress: ${progress}%`);
        },
      })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
  },
};
</script>
